import React from 'react';
import PropTypes from 'prop-types';

import { practiceProfilePropType } from '../../propTypes/index';
import PracticeTitle from '../PracticeHeader/PracticeTitle/index';
import PracticeContact from '../PracticeInfo/PracticeContact/index';
import PracticeDescription from '../PracticeInfo/PracticeDescription/index';
import ServiceButton from './ServiceButton/index';
import OpeningHours from '../PracticeInfo/OpeningHours/index';
import Section from '../PracticeInfo/Section/index';
import styles from './desktopView.module.css';

const DesktopView = ({ practice, scrollFn, goScripts, locationSelected }) => (
  <div className={styles.container}>
    <PracticeTitle practice={practice} />
    <div className={styles.mainContent}>
      <PracticeDescription description={practice.Description} />
      <Section content={practice.Specialties} title="Our Specialties" />
      <Section
        className={styles.languages}
        content={practice.Language}
        title="Languages we speak"
      />
      <PracticeContact
        practice={practice}
        locationSelected={locationSelected}
      />
    </div>
    <div className={styles.sideContent}>
      <ServiceButton
        type={practice.AllowsBookingBy}
        service={1}
        onClick={scrollFn}
      />
      {practice.AllowsOnlineScripts && (
        <ServiceButton
          type={practice.AllowsScriptsBy}
          service={2}
          onClick={goScripts}
        />
      )}
      <OpeningHours hours={practice.OpeningHours} note={practice.HourNote} />
    </div>
    <div className={styles.copyright}>&#169; 2016 Vensa Health</div>
  </div>
);

DesktopView.propTypes = {
  practice: practiceProfilePropType,
  scrollFn: PropTypes.func.isRequired,
};

export default DesktopView;
